import { ReactNode } from 'react';
import styles from './ChartCard.module.css';
import { ActionButton, PlantIcon } from '@practium/ui';

interface ChartCardProps {
	title: string;
	subtitle?: string;
	buttonText?: string;
	onButtonClick?: () => void;
	children: ReactNode;
	className?: string;
	isEmpty?: boolean;
	emptyMessage?: string;
	isLoading?: boolean;
	skeleton?: ReactNode;
}

export const ChartCard = ({
	title,
	subtitle,
	buttonText,
	onButtonClick,
	children,
	className,
	isEmpty,
	emptyMessage = 'Nenhum dado disponível',
	isLoading,
	skeleton,
}: ChartCardProps) => {
	return (
		<div className={`${styles.card} ${className || ''}`}>
			<div className={styles.header}>
				<div className={styles.headerText}>
					<span className={styles.title}>{title}</span>
					{subtitle && <span className={styles.subtitle}>{subtitle}</span>}
				</div>
				{buttonText && onButtonClick && (
					<div className={styles.buttonWrapper}>
						<ActionButton text={buttonText} onClick={onButtonClick} />
					</div>
				)}
			</div>
			<div className={styles.content}>
				{isLoading ? (
					skeleton
				) : isEmpty ? (
					<div className={styles.emptyState}>
						<PlantIcon className={styles.emptyIcon} />
						<span className={styles.emptyMessage}>{emptyMessage}</span>
					</div>
				) : (
					children
				)}
			</div>
		</div>
	);
};
